export default {
  sv: {
    navlabel: 'Webbplatsväljare',
  },
  en: {
    navlabel: 'Website selector',
  },
  da: {
    navlabel: 'Webstedsvælger',
  },
  no: {
    navlabel: 'Nettstedsvelger',
  },
  fi: {
    navlabel: 'Verkkosivun valitsin',
  },
  de: {
    navlabel: 'Website-Selektor',
  },
};
